import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0F0805] text-white py-14 px-6 md:px-10">
      {/* Top accent */}
      <div className="max-w-7xl mx-auto">
        <div className="h-px bg-gradient-to-r from-transparent via-[#E8B86D]/40 to-transparent mb-12" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/a5d1b8cb-aaa2-4cf9-95cd-76f3854cad51.png"
              alt="Elora Beauty Lounge"
              className="h-10 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-white/45 text-sm leading-relaxed font-light mb-5">
              Premium güzellik hizmetleri ile kendinizi en iyi hissedin. Uzman kadromuz her zaman yanınızda.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              {[
                { ikon: "ri-instagram-line", href: "#" },
                { ikon: "ri-facebook-circle-line", href: "#" },
                { ikon: "ri-youtube-line", href: "#" },
                { ikon: "ri-tiktok-line", href: "#" },
              ].map((s) => (
                <a
                  key={s.ikon}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/8 text-white/50 hover:bg-[#E8B86D] hover:text-[#1A0F0A] transition-all duration-200 cursor-pointer"
                >
                  <i className={`${s.ikon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4
              className="text-[#E8B86D] font-bold text-xs uppercase tracking-[0.2em] mb-5"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Hizmetler
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Cilt Yenileme Paketi", slug: "cilt-yenileme-paketi" },
                { label: "Lazer Epilasyon", slug: "lazer-epilasyon" },
                { label: "Kalıcı Dudak Renklendirme", slug: "dudak-renklendirme" },
                { label: "G5 Sıkılaşma", slug: "g5-sikilasma" },
                { label: "Hydrafacial Bakım", slug: "hydrafacial-bakim" },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={`/hizmetler/${item.slug}`}
                    className="text-white/45 hover:text-[#E8B86D] text-sm transition-colors cursor-pointer font-light flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line text-[#E8B86D]/0 group-hover:text-[#E8B86D] transition-colors text-xs" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-[#E8B86D] font-bold text-xs uppercase tracking-[0.2em] mb-5"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              İletişim
            </h4>
            <ul className="space-y-3.5">
              <li className="flex items-start gap-3 text-white/45 text-sm font-light">
                <i className="ri-map-pin-line text-[#E8B86D] mt-0.5 flex-shrink-0" />
                Bağcılar Mah. Güzellik Cad. No:12, İstanbul
              </li>
              <li className="flex items-center gap-3 text-white/45 text-sm font-light">
                <i className="ri-phone-line text-[#E8B86D] flex-shrink-0" />
                +90 500 123 45 67
              </li>
              <li className="flex items-center gap-3 text-white/45 text-sm font-light">
                <i className="ri-mail-line text-[#E8B86D] flex-shrink-0" />
                info@elorabeauty.com
              </li>
              <li className="flex items-center gap-3 text-white/45 text-sm font-light">
                <i className="ri-time-line text-[#E8B86D] flex-shrink-0" />
                Pzt–Cmt: 09:00 – 20:00
              </li>
            </ul>
          </div>
        </div>

        <div className="h-px bg-white/8 mb-6" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs font-light">
            © 2026 Elora Beauty Lounge. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-white/25 hover:text-[#E8B86D] text-xs transition-colors cursor-pointer font-light">Gizlilik Politikası</a>
            <a href="#" className="text-white/25 hover:text-[#E8B86D] text-xs transition-colors cursor-pointer font-light">Kullanım Koşulları</a>
          </div>
        </div>
      </div>
    </footer>
  );
}